import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AreaAdminDialog({ area, onOpenChange }) {
  const [f, setF] = useState({ admin_nomor: "", admin_nama: "", admin_password: "" });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => { if (area) { setF({ admin_nomor: "", admin_nama: "", admin_password: "" }); setErr(""); } }, [area]);
  const submit = async (e) => {
    e.preventDefault(); setSaving(true); setErr("");
    try { const r = await api.post(`/master/areas/${area.kode}/admin`, f); toast.success(r.data.message); onOpenChange(false); }
    catch (ex) { setErr(ex.response?.data?.detail || "Gagal menyimpan admin area"); } finally { setSaving(false); }
  };
  return (
    <Dialog open={!!area} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="area-admin-dialog">
        <DialogHeader>
          <DialogTitle>Admin Area {area?.kode}</DialogTitle>
          <DialogDescription>Buat akun admin baru untuk area ini, atau reset kata sandi admin yang sudah ada (isi nomor pegawai yang sama).</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1.5"><Label>No. Pegawai *</Label><Input value={f.admin_nomor} onChange={(e) => setF((s) => ({ ...s, admin_nomor: e.target.value.toUpperCase() }))} required data-testid="area-admin-dialog-nomor" /></div>
          <div className="space-y-1.5"><Label>Nama</Label><Input value={f.admin_nama} onChange={(e) => setF((s) => ({ ...s, admin_nama: e.target.value }))} data-testid="area-admin-dialog-nama" /></div>
          <div className="space-y-1.5"><Label>Kata Sandi *</Label><Input type="password" value={f.admin_password} onChange={(e) => setF((s) => ({ ...s, admin_password: e.target.value }))} required minLength={6} data-testid="area-admin-dialog-password" /></div>
          {err && <p className="text-sm text-rose-600">{err}</p>}
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Batal</Button>
            <Button type="submit" disabled={saving} className="bg-blue-600 hover:bg-blue-700 text-white gap-2" data-testid="area-admin-dialog-submit">{saving && <Loader2 className="h-4 w-4 animate-spin" />}Simpan</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
